// extracted by mini-css-extract-plugin
export default {"BetaLabel":"RegexField-module__BetaLabel--qzWHR","TestButton":"RegexField-module__TestButton--unRm7"};